import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { UserService } from 'src/app/data-services/user.service';
import { first } from 'rxjs/operators';
import { NgForm, FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { PostService } from 'src/app/data-services/post.service';
import {VoteQService} from 'src/app/data-services/vateQ.service';
import { HttpClient } from '@angular/common/http';
import {formatDate} from '@angular/common';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-newsfeed',
  templateUrl: './newsfeed.component.html',
  styleUrls: ['./newsfeed.component.css']
})
export class NewsfeedComponent implements OnInit {
  postForm: FormGroup;
  commentForm: FormGroup;
  FanvoteForm: FormGroup;
  currentUser: any;
  suggestedFriends = [];
  suggestedFollowers = [];
  posts: any;
  submitted: boolean;
  errorFlag: boolean;
  visible: boolean;
  userData: any = {};
  selectPost: any = {};
  selectComment: any = {};
  selectPostId: number;
  comments: any;
  public show: number;
  public buttonName: any = 'Show';
  today = new Date();
  imageName = '';
  videoName = '';
  isLoaderVisible = false;
  votes:any;
  QA11:any;
  QA12:any;
  QA13:any;
  QTotal:any;
  QAll:any;
  ULike: any;
  currentDate = formatDate(Date.now(),'yyyy-MM-dd','en-US');
  currentDate2 = formatDate(Date.now(),'yyyy-MM-dd HH:mm:ss','en-US');
  
  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private postService: PostService,
    private VoteQService:VoteQService,
    private http:HttpClient,
    public fb:FormBuilder,
  ) {
    window.scrollTo(0, 0);
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.userData = JSON.parse(localStorage.getItem('userData'));
  }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    // this.getProfile();
    this.suggestsFriends();
    this.suggestsFollowers();
    this.loadAllQuestions();
    this.loadAllfansAnw();
    this.loadAllPost();

    this.postForm = this.formBuilder.group({
      user_id: this.currentUser.success.user.id,
      content: ['', Validators.required],
      image: [''],
      video: [''],
      type: [''],
    });

    this.commentForm = this.formBuilder.group({
      content: ['', Validators.required],
      created_at :formatDate(Date.now(),'yyyy-MM-dd HH:mm:ss','en-US'),
      updated_at :formatDate(Date.now(),'yyyy-MM-dd HH:mm:ss','en-US'),
      post_id: '',
    });

  }
    urlify(text: any) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, function(url: string) {
        return `<a href="${url}" target="_blank">${url}</a>`;
      })
  }
  suggestsFriends() {
    this.isLoaderVisible = true;
    const data = {
      userId: this.currentUser.success.user.id,
    };
    this.userService.getSuggestFriends(data).pipe(first<any[]>()).subscribe(suggestedFriends => this.suggestedFriends = suggestedFriends);
    this.isLoaderVisible = false;
  }

  suggestsFollowers() {
    this.isLoaderVisible = true;
    const data = {
      userId: this.currentUser.success.user.id,
    };

    this.userService.getSuggestFollowers(data).pipe(first<any[]>())
      .subscribe(suggestedFollowers => this.suggestedFollowers = suggestedFollowers);
    this.isLoaderVisible = false;
  }

  /////////////////////////////////////// Posts Code
  loadAllPost() {
    this.isLoaderVisible = true;
    const data = {
      user_id: this.currentUser.success.user.id,
    };
    this.postService.getNewsFeed(data).pipe().subscribe(posts => this.posts = posts);
    this.isLoaderVisible = false;
  }
  onImageSelect(event) {
    const image = event.target.files[0];
    const type = event.target.files[0].type;
    if (type.match(/image\/*/) === null) {
      alert('Only Image  are supported');
      return;
    }
    this.imageName = event.target.files[0].name;
    this.postForm.get('type').setValue(type);
    this.postForm.get('image').setValue(image);

  }
  onVideoSelect(event) {
    const video = event.target.files[0];
    const type = event.target.files[0].type;
    if (type.match(/video\/*/) === null) {
      alert('Only video  are supported');
      return;
    }
    this.videoName = event.target.files[0].name;
    this.postForm.get('type').setValue(type);
    this.postForm.get('video').setValue(video);

  }
  get f() { return this.postForm.controls; }
  setPost() {
    this.submitted = true;
    this.errorFlag = false;
    if (this.postForm.invalid) {
      return;
    }
    this.isLoaderVisible = true;
    const fd = new FormData();
    fd.append('user_id', this.postForm.get('user_id').value);
    fd.append('content', this.postForm.get('content').value);
    fd.append('type', this.postForm.get('type').value);
    fd.append('image', this.postForm.get('image').value);
    fd.append('video', this.postForm.get('video').value);

    this.postService.post(fd).pipe(first()).subscribe(
      data => {
        this.isLoaderVisible = false;
        this.visible = false;
        this.errorFlag = false;
        this.submitted = true;
        this.loadAllPost();
      },
      error => {
        this.isLoaderVisible = false;
        this.visible = false;
        this.errorFlag = false;

      }
    );
    this.postForm = this.formBuilder.group({
      user_id: this.currentUser.success.user.id,
      content: [''],
      image: [''],
      type: [''],
    });
    // this.fileName = '';

  }
  deletePost(modal: any) {
    this.isLoaderVisible = true;
    const data = {
      postId: this.selectPost.id,

    };
    this.postService.deletePost(data).subscribe(
      posts => {
        this.isLoaderVisible = false;
        modal.hide();
        this.loadAllPost();
      },
      error => {
        console.log(error);
        this.isLoaderVisible = false;

      }
    );
  }
  openDeleteModal(modal: any, post: any) {
    this.selectPost = post;
    modal.show();
  }
  openEditModal(modal: any, post: any) {
    this.selectPost = post;
    modal.show();
  }
  updatePost(modal: any) {
    this.isLoaderVisible = true;
    const data = {
      id: this.selectPost.id,
      content: this.selectPost.content,
      attachment: this.selectPost.attachment,
    };
    this.postService.updatePost(data).subscribe(
      updatedPost => {
        this.isLoaderVisible = false;
        modal.hide();
      },
      error => {
        console.log(error);
        this.isLoaderVisible = false;
      }
    );
  }

  closeEditModal(modal: any) {
    modal.hide();
    this.loadAllPost();
  }


  ///////////////////////////////////////// Likes Codes

  likeUnlike(id: number) {
    this.isLoaderVisible = true;
    const data = {
      post_id: id,
      user_id: this.currentUser.success.user.id,

    };
    this.postService.likeUnlike(data).pipe(first()).subscribe(
      succuss => {
        this.isLoaderVisible = false;
        this.errorFlag = false;
        this.loadAllPost();
        this.Whoieslike(id);
      },
      error => {
        this.isLoaderVisible = false;
        this.errorFlag = false;
      }
    );
  }

  ///////////////////////////////////////// Comments Codes

  doComment(pId: number) {
    this.isLoaderVisible = true;

    if (this.commentForm.valid === true) {
      this.commentForm.value.post_id = pId;
      this.commentForm.value.commenter_id = this.currentUser.success.user.id;
      this.postService.comment(this.commentForm.value).pipe(first()).subscribe(
        succuss => {
          this.isLoaderVisible = false;
          this.loadAllPost();
          this.showComments(pId);
        },
        error => {
          console.log(error);
          this.isLoaderVisible = false;
        }
      );
    } else {
      this.isLoaderVisible = false;
    }
    this.commentForm.reset();

  }

  openCommentDeleteModal(modal: any, comment: any, postId: number) {
    this.selectComment = comment;
    this.selectPostId = postId;
    modal.show();
  }

  deleteComment(modal: any, postId: number) {
    this.isLoaderVisible = true;
    const data = {
      commentId: this.selectComment.commentId,
      post_id: this.selectPostId,
    };
    this.postService.deleteComment(data).subscribe(
      comments => {
        this.isLoaderVisible = false;
        modal.hide();
        this.showComments(postId);
      },
      error => {
        this.isLoaderVisible = false;
        console.log(error);
      }
    );
  }

  toggle(Id: number) {
    if (this.show !== Id) {
      this.show = Id;
    } else {
      this.show = 0;
    }

    this.showComments(Id);

    if (this.show) {
      this.buttonName = 'Show';
    } else {
      this.buttonName = 'Hide';
    }

  }

  showComments(Id: number) {
    this.isLoaderVisible = true;
    const data = {
      postId: Id,
    };
    this.postService.getAllComments(data).pipe(first()).subscribe(comments => this.comments = comments);
    this.isLoaderVisible = false;

  }

  Whoieslike(id: number) {
    //this.isLoaderVisible = true;
    const data = {
      post_id: id,
      user_id: this.currentUser.success.user.id,

    };
    this.postService.whoLikedMyPost(data).pipe(first()).subscribe(
      getlikeuser => {
      this.ULike = getlikeuser;
    });
  }
  loadAllQuestions() {
      const fangetdata = {
        user_id: this.currentUser.success.user.email,
      };
      this.VoteQService.getAllQA(fangetdata).pipe(first()).subscribe(
        fangetdata => {
          this.votes = fangetdata;
          for (const vote of this.votes) {
            // post.type = post.type.split('/')[0];
              //vote.VoteQ =vote.Qnumber;
              if(vote.Qstatus == 1)
              {
                this.FanvoteForm = this.fb.group({
                  user_id: this.currentUser.success.user.email,
                  QVA:[''],
                  VoQuest:[vote.VoteQ],
                  VoteNo:[vote.Qnumber],
                  Votedate:formatDate(Date.now(),'yyyy-MM-dd','en-US')
                });
                  var QA11:any = new FormData();
                    QA11.append('VQno', this.FanvoteForm.get('VoteNo').value);
                  this.VoteQService.getAllQA1(QA11).subscribe(
                  QA111=>{
                  this.QA11 =QA111;
                  });
  
  
                  var QA12:any = new FormData();
                    QA12.append('VQno', this.FanvoteForm.get('VoteNo').value);
                  this.VoteQService.getAllQA2(QA12).subscribe(
                  QA112=>{
                    this.QA12 =QA112;
                  });
                  
  
                  var QA13:any = new FormData();
                    QA13.append('VQno', this.FanvoteForm.get('VoteNo').value);
                  this.VoteQService.getAllQA3(QA13).subscribe(
                  QA113=>{
                  this.QA13 =QA113;
                  });
  
                  var QAll:any = new FormData();
                  QAll.append('VQno', this.FanvoteForm.get('VoteNo').value);
                  this.VoteQService.getAllQAll(QAll).subscribe(
                    QAll=>{
                  this.QAll =QAll;
                  });
              }
  
          }
        }
  
      );
    }
    loadAllfansAnw() {
      const data = {
        user_id: this.currentUser.success.user.email,
      };
      this.VoteQService.getAllQA(data).pipe(first()).subscribe(
        votes => {
        this.votes = votes;
        for (const vote of this.votes) {
          // post.type = post.type.split('/')[0];
            //vote.VoteQ =vote.Qnumber;
            if(vote.Qstatus == 1)
            {
              
            }
    }});
    }
    setvotfan(){
      var fd1:any = new FormData();
      fd1.append('UserName', this.FanvoteForm.get('user_id').value);
      fd1.append('VoteQ', this.FanvoteForm.get('VoQuest').value);
      fd1.append('VoteA', this.FanvoteForm.get('QVA').value);
      fd1.append('VQno', this.FanvoteForm.get('VoteNo').value);
      fd1.append('VDate', this.FanvoteForm.get('Votedate').value);
      //this.http.post('http://127.0.0.1:8000/api/v1/votefans', fd1).subscribe(
        this.VoteQService.postQ(fd1).pipe(first()).subscribe(
        response => {
          this.toastrService.success('Thanks for share with us , Your voting is sended', 'Message!');
          this.visible = false;
          this.errorFlag = false;
          this.submitted = true;
          this.loadAllQuestions();
        },
        error => {
          console.log(error);
          this.toastrService.error('Something went wrong Try again', 'Message!');
          this.visible = false;
          this.errorFlag = false;
        }
      )
      
    }
      calculateDiff(sentDate) {
    var date1:any = new Date(sentDate);
    var date2:any = new Date();
    var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24 * 30 * 12));
    if(diffDays == 0)
    {
      var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24 * 30));
      if(diffDays == 0)
      {
        var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24 ));
        if(diffDays == 0)
        {
          var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60));
          if(diffDays == 0)
          {
            var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 ));
            if(diffDays == 0)
            {
              
            }
            else
            {
              return diffDays +" minutes ago";
            }
          }
          else
          {
            return diffDays +" hours ago";
          }
        }
        else
        {
          return diffDays +" day ago";
        }
      }
      return diffDays +" month ago";
    }
    else
    {
      return diffDays +" year ago";
    }
  }
}
